import { render, staticRenderFns } from "./FormularioAlterarSenha.vue?vue&type=template&id=f29a583a&scoped=true"
import script from "./FormularioAlterarSenha.vue?vue&type=script&lang=js"
export * from "./FormularioAlterarSenha.vue?vue&type=script&lang=js"
import style0 from "./FormularioAlterarSenha.vue?vue&type=style&index=0&id=f29a583a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29a583a",
  null
  
)

export default component.exports